import { downloadDocument } from '@/services/services/documentsService';

const downloadDocumentMixin = {
  data: () => ({
    downloading: false,
  }),
  computed: {
    url() {
      return this.$store.getters['documents/url'];
    },
  },
  methods: {
    downloadDocument,
    download(item) {
      if (this.url[item.id]) {
        window.open(this.url[item.id]);
      } else {
        this.downloading = item.id;
        this.downloadDocument(item.id)
          .then((file) => {
            const url = window.URL.createObjectURL(file);
            this.$store.dispatch('documents/addUrl', { url, uid: item.id });
            this.downloading = false;
            window.open(url);
          })
          .catch(() => {
            this.downloading = false;
          });
      }
    },
  },
};

export default downloadDocumentMixin;
